/**
 * vue 业务相关的局部视图组样配置入口
 * 多处使用到（比如大于2处以上）的地方进行全局注册
 * 否则就单独引入，或者只作为路由视图组件的局部组件引入
 */
import loading from './loading'
import debounce from './debounce'

const directives = {
  loading,
  debounce,
}

export default {
  install(Vue) {
    Object.keys(directives).forEach((key) => {
      Vue.directive(key, directives[key])
    })
  },
  debounce,
}
